export default "__VITE_ASSET__CIIU_r17__"